import './polyfill'
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import { detectedCulture } from 'utilities/common/culture'
import siteConfig from 'siteConfig'

const baseEndPoint = siteConfig.udi.endpoint
const redirectUri = `${window.location.origin}/${detectedCulture.code}/udi-return`
const urlParams = new URLSearchParams(window.location.search)
let languageCode = detectedCulture.languageCode
if ((detectedCulture.countryCode === 'BE' || detectedCulture.countryCode === 'CA') && urlParams.has('language')) {
  languageCode = urlParams.get('language')
}

const logoutCultureMapping = {
  'en-gb': 'https://www.philips.co.uk',
  'en-us': 'https://www.philips.com',
  'en-ca': 'https://www.philips.ca',
  'de-de': 'https://www.philips.de',
  'pl-pl': 'https://www.philips.pl',
  'nl-nl': 'https://www.philips.nl',
  'es-es': 'https://www.philips.es',
  'it-it': 'https://www.philips.it',
  'de-at': 'https://www.philips.at',
  'nl-be': 'https://www.philips.be',
  'fr-fr': 'https://www.philips.fr',
  'sv-se': 'https://www.philips.se',
  'ro-ro': 'https://www.philips.ro',
  'cs-cz': 'https://www.philips.cz'
  

}
const logoutRedirectUrl = logoutCultureMapping[detectedCulture.code]
const profileUri = baseEndPoint +
  `/auth-ui/profile?redirect_uri=${encodeURIComponent(redirectUri)}` +
  `&client_id=${siteConfig.udi.clientId}` +
  `&ui_locales=${languageCode}`

const settings = {
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: baseEndPoint + '/login',
  client_id: siteConfig.udi.clientId,
  response_type: 'code',
  scope: 'openid profile email consumerIdentityService/user:update/consent_email_marketing',
  filterProtocolClaims: true,
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 3300,
  silent_redirect_uri: redirectUri,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: logoutRedirectUrl,
  metadata: {
    issuer: baseEndPoint + '/login',
    token_endpoint: baseEndPoint + '/login/token',
    authorization_endpoint: baseEndPoint + '/login/authorize',
    userinfo_endpoint: baseEndPoint + '/profiles/oidc/userinfo',
    end_session_endpoint: baseEndPoint + '/auth-ui/logout',
    jwks_uri: baseEndPoint + '/login/jwk'
  }
}

const userManager = new UserManager(settings)
userManager.clearStaleState()

const loginStateKey = 'loginState'

const claims = JSON.stringify({
  id_token: {
    'uuid': null,
    'address.address1': null,
    'address.address2': null,
    'address.address3': null,
    'address.house_number': null,
    'address.locality': null,
    'address.region': null,
    'address.postal_code': null,
    'address.country': null,
    'phonenumbers.main': null,
    'phonenumbers.mobile': null,
    'consent_terms_and_conditions.opted_in_at': null,
    'consent_email_marketing.opted_in': null
  },
  userinfo: {
    'uuid': null,
    'address.address1': null,
    'address.address2': null,
    'address.address3': null,
    'address.house_number': null,
    'address.locality': null,
    'address.region': null,
    'address.postal_code': null,
    'address.country': null,
    'phonenumbers.main': null,
    'phonenumbers.mobile': null,
    'consent_terms_and_conditions.opted_in_at': null,
    'consent_email_marketing.opted_in': null
  }
})

const login = async function (loginState) {
  console.log(loginState)
  console.log(claims)
  if (loginState) {
    await userManager.settings.userStore.set(loginStateKey, JSON.stringify(loginState))
  }
  await userManager.signinRedirect({
    extraQueryParams: {
      'ui_locales': languageCode,
      'claims': claims
    }
  })
}

const signUp = async function (loginState) {
  if (loginState) {
    await userManager.settings.userStore.set(loginStateKey, JSON.stringify(loginState))
  }
  await userManager.signinRedirect({
    extraQueryParams: {
      'ui_locales': languageCode,
      'claims': claims,
      'prompt': 'create'
    }
  })
}

const loginCallback = async function () {
  const user = await userManager.signinRedirectCallback()
  const loginSateString = await userManager.settings.userStore.get(loginStateKey)
  const loginState = loginSateString ? JSON.parse(loginSateString) : {}
  return {
    user,
    loginState
  }
}

const loginSlientCallback = async function (url) {
  return userManager.signinSilentCallback(url)
}

const logout = async function () {
  await userManager.settings.userStore.remove(loginStateKey)
  const user = userManager.getUser()
  if (user && !user.expired) {
    await userManager.signoutRedirect({
      extraQueryParams: {
        client_id: settings.client_id
      }
    })
  } else {
    await userManager.clearStaleState()
  }
}

const redirectToProfile = async function () {
  window.location.href = profileUri
}

const getToken = async function () {
  const user = await userManager.getUser()
  if (user && !user.expired) {
    return user.access_token
  }

  return null
}

const hasSession = async function () {
  try {
    await userManager.querySessionStatus({
      extraQueryParams: {
        'ui_locales': languageCode,
        'claims': claims
      }
    })
    return true
  } catch (e) {
    return false
  }
}

const removeUser = async function () {
  return userManager.removeUser()
}

export default {
  loginCallback,
  logout,
  login,
  signUp,
  getToken,
  redirectToProfile,
  hasSession,
  removeUser,
  loginSlientCallback
}
